import React from 'react';
import { Check, Star } from 'lucide-react';
import StripeCheckoutButton from './StripeCheckoutButton';
import type { StripeProduct } from '../../stripe-config';

interface PricingCardProps {
  product: StripeProduct;
  features?: string[];
  popular?: boolean;
}

export default function ProductCard({ product, features = [], popular = false }: PricingCardProps) {
  return (
    <div className={`relative bg-white rounded-2xl shadow-lg border-2 ${
      popular ? 'border-green-500' : 'border-gray-200'
    } p-8`}>
      {popular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <div className="bg-green-500 text-white px-4 py-1 rounded-full text-sm font-medium flex items-center">
            <Star className="h-4 w-4 mr-1" />
            Most Popular
          </div>
        </div>
      )}

      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">{product.name}</h3>
        <div className="text-4xl font-bold text-gray-900 mb-1">
          ${product.price.toFixed(2)}
          {product.mode === 'subscription' && (
            <span className="text-lg font-normal text-gray-600">/month</span>
          )}
        </div>
        <p className="text-gray-600">{product.description}</p>
      </div>

      {features.length > 0 && (
        <ul className="space-y-4 mb-8">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
              <span className="text-gray-700">{feature}</span>
            </li>
          ))}
        </ul>
      )}

      <StripeCheckoutButton
        priceId={product.priceId}
        className="w-full"
      >
        Get Started
      </StripeCheckoutButton>
    </div>
  );
}